export class User {
  id: string;
  code: string;
  username: string;
  client: string;
  type: UserType;
  state: string;
  phone: string;
  email: string;
  canConfirmBid: boolean;
  isAssisted: boolean;

  constructor(
    id: string,
    code: string,
    username: string,
    client: string,
    type: UserType,
    phone: string,
    email: string,
    state: string,
    canConfirmBid: boolean,
    isAssisted: boolean = false,
  ) {
    this.id = id;
    this.code = code;
    this.username = username;
    this.client = client;
    this.type = type;
    this.phone = phone;
    this.email = email;
    this.state = state;
    this.canConfirmBid = canConfirmBid;
    this.isAssisted = isAssisted;
  }

  static states() {
    return [
      { id: 'H', text: 'Habilitado' },
      { id: 'I', text: 'Inhabilitado' },
    ];
  }
}

export interface UserStats {
  clients: number;
  invited: number;
  total: number;
}

export interface UserConnected {
  displayName: string;
  timestamp: any;
  userName: string;
}

export enum UserType {
  VIRTUAL = 'Virtual',
  ONSITE = 'Presencial',
}
